import React, {useEffect, useRef, useState} from 'react';
import {NavLink} from 'react-router-dom';
import {Button, CircularProgress, Typography} from '@mui/material';
import config from "../config";
import './Login.scss';

const PARTICLE_COLORS = [
    'rgba(99, 102, 241,',
    'rgba(139, 92, 246,',
    'rgba(167, 139, 250,',
    'rgba(79, 70, 229,',
];

const LoggedOutPage = () => {
    const canvasRef = useRef(null);
    const [isLoggingOut, setIsLoggingOut] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setIsLoggingOut(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resize();
        window.addEventListener('resize', resize);

        const particles = Array.from({length: 70}, () => ({
            x: Math.random() * window.innerWidth,
            y: Math.random() * window.innerHeight,
            r: Math.random() * 2.5 + 0.5,
            speed: Math.random() * 0.6 + 0.25,
            opacity: Math.random() * 0.6 + 0.2,
            opacityDir: Math.random() > 0.5 ? 1 : -1,
            opacitySpeed: Math.random() * 0.006 + 0.002,
            color: PARTICLE_COLORS[Math.floor(Math.random() * PARTICLE_COLORS.length)],
            drift: (Math.random() - 0.5) * 0.4,
        }));

        let animId;
        const draw = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            particles.forEach(p => {
                p.y -= p.speed;
                p.x += p.drift;
                p.opacity += p.opacityDir * p.opacitySpeed;
                if (p.opacity > 0.9 || p.opacity < 0.1) p.opacityDir *= -1;
                if (p.y < -10) {
                    p.y = canvas.height + 10;
                    p.x = Math.random() * canvas.width;
                }
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                ctx.fillStyle = `${p.color}${p.opacity})`;
                ctx.shadowBlur = 8;
                ctx.shadowColor = `${p.color}0.9)`;
                ctx.fill();
                ctx.shadowBlur = 0;
            });
            animId = requestAnimationFrame(draw);
        };
        draw();

        return () => {
            cancelAnimationFrame(animId);
            window.removeEventListener('resize', resize);
        };
    }, []);

    const background = (
        <>
            <canvas ref={canvasRef} className="login-particles-canvas" aria-hidden="true" />
            <div className="login-bg-orbs" aria-hidden="true">
                <div className="orb orb-1" />
                <div className="orb orb-2" />
                <div className="orb orb-3" />
                <div className="orb orb-4" />
            </div>
        </>
    );

    if (isLoggingOut) {
        return (
            <div className="login-container">
                {background}
                <div className="login-card loading-state">
                    <CircularProgress size={48} style={{color: '#6366f1', marginBottom: '24px'}} />
                    <Typography variant="h6" className="primary-font" style={{fontWeight: 500}}>
                        Logging out...
                    </Typography>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            {background}
            <div className="login-card">
                <div className="login-header">
                    <Typography
                        variant="h3"
                        className="login-title"
                        style={{fontFamily: 'Cookie, cursive', fontSize: '48px', marginBottom: '4px'}}
                    >
                        Verdantime
                    </Typography>
                    <div className="login-accent-bar" />
                    <Typography variant="body2" className="secondary-font" style={{marginTop: '16px', marginBottom: 0}}>
                        You've been signed out.
                    </Typography>
                </div>

                <NavLink to={`${config.uiBaseUrl}/`} style={{textDecoration: 'none'}}>
                    <Button
                        className="login-button primary-font"
                        variant="contained"
                        fullWidth
                        size="large"
                    >
                        Return to Login
                    </Button>
                </NavLink>
            </div>
        </div>
    );
};

export default LoggedOutPage;
